import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { connect } from 'react-redux';
import * as Actions from 'actions';
import { Tab, Nav, Row, Col, NavItem, NavDropdown, MenuItem } from 'react-bootstrap';
import { ClientDetails, ClientContacts, ClientTaskList, ClientNewTask } from './';

class ClientTasks extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { address, name, phone, last_updated, _id, date_added } = this.props.client;
    return (
      <div className="row">
        <div className="col-xs-12 col-md-4 col-lg-3">
          <ClientDetails client={this.props.client} />
          <ClientContacts />
        </div>
        <div className="col-xs-12 col-md-8 col-lg-9 animated fadeInDown">
          <Tab.Container id="TaskView" defaultActiveKey="ActiveTasks">
            <Row className="clearfix">
              <Col sm={12}>
                <Nav bsStyle="tabs">
                  <NavItem eventKey="ActiveTasks">
                    <i className="fa fa-exclamation"></i> Active
                  </NavItem>
                  <NavItem eventKey="History">
                    <i className="fa fa-check"></i> Completed
                  </NavItem>
                </Nav>
              </Col>
              <Col sm={12}>
                <Tab.Content animation>
                  <Tab.Pane eventKey="ActiveTasks">
                    <div className="row">
                			<div className="col-xs-12">
                        <h2 className="pb-lg">Manage Tasks <br/></h2>
                        <hr className="dotted short" />
                        <ClientNewTask clientId={this.props.client._id} creator={this.props.users.user} />
                        <ClientTaskList tasks={this.props.client.tasks} />
                      </div>
                		</div>
                  </Tab.Pane>
                  <Tab.Pane eventKey="History">
                    <h2 className="pb-lg">Completed Tasks</h2>
                    <hr className="dotted short" />
                  </Tab.Pane>
                </Tab.Content>
              </Col>
            </Row>
          </Tab.Container>
        </div>
      </div>
    );
  }
}

ClientTasks.contextTypes = {
  client : PropTypes.object,
}

const mapStateToProps = ({client, users}) => ({client, users});

export default connect(mapStateToProps, Actions)(ClientTasks);



// WEBPACK FOOTER //
// ./src/browser/components/client/client-tasks.js